const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceThankYouRequestRecord extends AbstractCloverRequestRecord {
    constructor() {
        // @link https://docs.clover.com/reference/show_thank_you
        const url = '/connect/v1/device/thank-you';
        super(
            'POST',
            url
        );
    }
}

module.exports = CloverDeviceThankYouRequestRecord;
